module.exports = __webpack_public_path__ + "073ef3722550b4413b9bfac7dc9d9e37.pdf";